import { useEffect, useMemo, useState } from 'react'
import { toastError } from '../../../../FormComponents/Toasts'
import { buildDefaultVisibleColumnsByTab, mergeSavedBudgetColumnVisibility } from './BudgetDetailsPanelRowBuilders'
import { forcedHiddenColumnsFromPlatforms } from './BudgetDetailsPanelConfig'
import { saveBudgetColumnVisibility } from './BudgetDetailsPanelPersistence'

export default function useBudgetColumnVisibility({
  campaign,
  campaignScenario,
  customFieldsTableConfig,
  platformsVisibilityKey,
  customFieldsKey,
  forcedHiddenColumns,
}) {
  const [isColumnEditMode, setIsColumnEditMode] = useState(false)
  const [visibleColumnsByTab, setVisibleColumnsByTab] = useState(() => buildDefaultVisibleColumnsByTab({}, null))
  const [draftColumnsByTab, setDraftColumnsByTab] = useState(null)

  const savedVisibilityKey = useMemo(() => {
    const raw = campaignScenario?.budget_table_column_visibility
    return raw && typeof raw === 'object' ? JSON.stringify(raw) : ''
  }, [campaignScenario?.budget_table_column_visibility])

  useEffect(() => {
    if (!campaignScenario?.id) return
    const hidden = forcedHiddenColumnsFromPlatforms(campaign?.platforms)
    setVisibleColumnsByTab(mergeSavedBudgetColumnVisibility(campaignScenario.budget_table_column_visibility, hidden, customFieldsTableConfig))
  }, [campaignScenario?.id, savedVisibilityKey, platformsVisibilityKey, customFieldsKey, campaign?.platforms, customFieldsTableConfig])

  // Tab-scoped: caller slices visibleColumnsByTab[tabKey] for whichever tab is active.
  const toggleColumn = (tabKey, key) => {
    if (!tabKey) return
    if (forcedHiddenColumns[key]) return
    setDraftColumnsByTab(prev => ({
      ...prev,
      [tabKey]: {
        ...prev[tabKey],
        [key]: !prev[tabKey][key],
      },
    }))
  }

  const toggleColumnEditMode = () => {
    if (!isColumnEditMode) {
      setDraftColumnsByTab(JSON.parse(JSON.stringify(visibleColumnsByTab)))
      setIsColumnEditMode(true)
      return
    }

    const next = draftColumnsByTab || visibleColumnsByTab
    setVisibleColumnsByTab(next)
    setDraftColumnsByTab(null)
    setIsColumnEditMode(false)

    if (campaignScenario?.id) {
      saveBudgetColumnVisibility(campaignScenario, next).catch(err => {
        console.error(err)
        const msg = err?.data?.error ?? err?.message
        toastError(typeof msg === 'string' ? msg : 'Failed to save visibility settings')
      })
    }
  }

  return {
    isColumnEditMode,
    visibleColumnsByTab,
    draftColumnsByTab,
    toggleColumn,
    toggleColumnEditMode,
  }
}
